import styled from 'styled-components';

export const Container = styled.div`
  font-size: 14px;
  width: 100%;
  padding: 16px;
  border: 1px solid ${({ theme }) => theme.grey.lighter};
  border-radius: 12px;
`;

export const Wrapper = styled.div`
  border-top: 1px solid rgba(204, 204, 204, 0.4);
  font-size: 14px;
  margin-top: 16px;
`;
